import create from "zustand";

const useShowErrorFlashStore = create((set: any) => ({
    showErrorFlash: false,
    setShowErrorFlash: (data: any) => set(() => ({ showErrorFlash: data })),
}));

export { useShowErrorFlashStore };
